import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { FormInput } from 'Common/Form';
import Button from 'Common/CustomButtons/Button';
import Clearfix from 'Common/Clearfix/Clearfix';
import { maxLengthValidation } from 'Utils';
const maxLength255 = maxLengthValidation(255);

@reduxForm({
    form: 'submissionComment',
    enableReinitialize: true,
})
export default class CommentForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        pristine: PropTypes.bool,
        submitting: PropTypes.bool,
        className: PropTypes.string,
    };

    render () {
        const { className, pristine, submitting, handleSubmit, onSubmit } = this.props;

        return (
            <form
                onSubmit={ handleSubmit(onSubmit) }
                id="submission.comments"
                className={ className }
            >
                <div className="field-wrapper-textarea field-wrapper-textarea-small">
                    <Field
                        name="comment"
                        component={ FormInput }
                        type="textarea"
                        label="comment"
                        validate={[maxLength255]}
                    />

                    <div>
                        <Button
                            color="success"
                            right
                            type="submit"
                            disabled={ pristine || submitting }
                            customClass='btn-comment-submit'
                        >
                            <FormattedMessage id={'button.comment.send'} />
                        </Button>
                    </div>
                </div>
                <Clearfix/>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/CommentForm.jsx